/**
 * Service: photosApi
 */
angular.module('acme.common.service.photosApi', [])
.service('PhotosApiService', [ '$http', function ($http) {

    return {

      service: '',

      init: function (endpoint) {
        this.service = endpoint + '/photos';
        return this;
      },

      remove: function(id) {
        return $http({
          method: 'delete',
          url: this.service + '/' + id
        });
      },

      upload: function(props) {

        var data = new FormData();

        angular.forEach(props.files, function(file) {
          data.append('file', file);
        });

        return $http({
          method: 'post',
          url: this.service + '/1',
          transformRequest: angular.identity,
          headers: {
            'Content-Type': undefined
          },
          data: data
        });

      }

    };

}]);